import { Model, View } from '@lernetz/ts-lib';

import template from './Heading.html';

export class Heading extends Model {

    public readonly id: string;
    public readonly level: number;
    public readonly marginTop: string;
    public readonly marginBottom: string;
    public readonly text: string;
    
    public constructor(dto) {
        super();

        this.id = dto.id;
        this.level = Number(dto.level || 4);
        this.marginTop = dto.marginTop || '';
        this.marginBottom = dto.marginBottom || '';
        this.text = dto.text;
    }
}

export class HeadingView extends View<Heading> {

    public constructor() {
        super({ template });
    }

    public init() {
        const { id, level, text } = this.data;
        this.node.innerHTML = `<h${level} id="heading-${id}" class="text-style -h${level} -h${level}-margin">${text}</h${level}>`;
        this.node.classList.add(`-h${level}`);
    }
}
